var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.627 377.374L313.371 422.628C300.875 435.124 280.615 435.124 268.117 422.628L138.508 293.016L70.625 360.898C61.477 370.047 47.709 372.785 35.756 367.836C23.789 362.879 16 351.223 16 338.27V111.996C16 103.16 19.58 95.16 25.369 89.371C31.16 83.582 39.158 80 47.998 80H274.271C287.221 80 298.877 87.789 303.838 99.754C308.787 111.707 306.047 125.477 296.898 134.625L229.016 202.504L358.627 332.116C371.125 344.616 371.123 364.874 358.627 377.374Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLeft);
export default __webpack_public_path__ + "static/media/up-left.6c3f6ba90dcbaba75da13e17d3abfeb8.svg";
export { ForwardRef as ReactComponent };